import { MdInfo } from "react-icons/md";

import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { Container, Content, StyledTabs } from "./styles";
import { Tabs, Tooltip } from "antd";
import DocumentNotSend from "../DocumentNotSend";
import EventEditionDocuments from "../EventEditionDocuments";
import DocumentApproval from "../DocumentApproval";
import { useState } from "react";

const Document = () => {
  const { TabPane } = Tabs;
  const intl = useIntl();
  const { contract } = useSelector((state) => state.initialSettings);
  const { permission } = useSelector((state) => state.auth);
  const [activeKey, setActiveKey] = useState("1");
  const { hasMandatoryDocuments } = useSelector(
    (state) => state.documentRequired
  );

  return (
    <Container>
      <StyledTabs activeKey={activeKey} onChange={(key) => setActiveKey(key)}>
        {permission.includes("ACCESS_UPLOAD_FLOW") && (
          <TabPane
            tab={
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div>{intl.formatMessage({ id: "document_send" })}</div>
                <Tooltip
                  title={intl.formatMessage({
                    id: "documents.mandatory_pending",
                  })}
                >
                  {hasMandatoryDocuments && contract.value && (
                    <MdInfo size={22} color="#EF4444" />
                  )}
                </Tooltip>
              </div>
            }
            key="1"
          >
            {contract.value && (
              <Content>
                <DocumentNotSend activeTab={activeKey} />
              </Content>
            )}
          </TabPane>
        )}

        {permission.includes("ACCESS_EVENT_EDITION_DOCUMENTS") && (
          <TabPane
            tab={intl.formatMessage({ id: "document_download" })}
            key="2"
          >
            {contract.value && (
              <Content>
                <EventEditionDocuments />
              </Content>
            )}
          </TabPane>
        )}

        {permission.includes("CLIENT_APPROVE_UPLOAD_FLOW") && (
          <TabPane
            tab={intl.formatMessage({ id: "sidebar.document_approval" })}
            key="3"
          >
            {contract.value && (
              <Content>
                <DocumentApproval activeTab={activeKey} />
              </Content>
            )}
          </TabPane>
        )}
      </StyledTabs>
    </Container>
  );
};

export default Document;
